import { createEmptyState } from 'data/createRandomState';
import {
  RENAME_GROUP,
  EDIT_GROUP_CODE,
  EDIT_GROUP_NUMBER,
  MOVE_GROUP,
  MOVE_GROUP_UP,
  MOVE_GROUP_DOWN,
  ADD_GROUP,
  SET_GROUPS_EXPANDED,
  SORT_GROUPS,
  SET_SHOULD_SYNC_EXPANDED_STATES,
  LEAD_SCHEDULE_REPORT_SAVE_SELECTED_GROUPS,
} from 'constants/actionTypes';
import {
  renameGroup,
  moveGroup,
  moveGroupUp,
  moveGroupDown,
  addGroup,
  editGroupCode,
  editGroupNumber,
  setGroupsExpanded,
  setShouldSyncExpandedStates,
  sortGroups,
  leadScheduleReportSaveSelectedGroups,
} from 'utils/stateToState';

export default function groups(state = createEmptyState().groups, action) {
  switch (action.type) {
    case RENAME_GROUP: {
      const { groupId, newName } = action;
      return renameGroup(state, groupId, newName);
    }
    case EDIT_GROUP_CODE: {
      const { groupId, groupCode } = action;
      return editGroupCode(state, groupId, groupCode);
    }
    case EDIT_GROUP_NUMBER: {
      const { groupId, groupNumber } = action;
      return editGroupNumber(state, groupId, groupNumber);
    }
    case MOVE_GROUP: {
      const { groupId, targetGroupId } = action;
      return moveGroup(state, groupId, targetGroupId);
    }
    case MOVE_GROUP_UP: {
      const { groupId } = action;
      return moveGroupUp(state, groupId);
    }
    case MOVE_GROUP_DOWN: {
      const { groupId } = action;
      return moveGroupDown(state, groupId);
    }
    case ADD_GROUP: {
      const { parentGroupId } = action;
      return addGroup(state, parentGroupId);
    }
    case SET_GROUPS_EXPANDED: {
      const { groupIds, expanded, shouldSyncExpandedStates } = action;
      return setGroupsExpanded(
        state,
        groupIds,
        expanded,
        shouldSyncExpandedStates
      );
    }
    case SET_SHOULD_SYNC_EXPANDED_STATES: {
      const { shouldSyncExpandedStates } = action;
      return setShouldSyncExpandedStates(state, shouldSyncExpandedStates);
    }
    case SORT_GROUPS: {
      const { groupId, field, sortingOrder, rows, cols } = action;
      return sortGroups(state, groupId, field, sortingOrder, rows, cols);
    }
    case LEAD_SCHEDULE_REPORT_SAVE_SELECTED_GROUPS: {
      const { savedGroupsIds } = action;
      return leadScheduleReportSaveSelectedGroups(state, savedGroupsIds);
    }
    default:
      return state;
  }
}
